import React from "react";
import ClassNames from "classnames";
import * as s from "./s.module.scss";
import { GatsbyImage, getImage } from "gatsby-plugin-image";


const FeaturedBlock = ({
  variant,
  featuredAbout,
  featuredTriumphs,
  theme,
  reverse,
  imageUrl,
  imageAlt,
  smallTitle,
  header,
  content,
  footer,
  headerStyle,
  icon
}) => {
  const featuredBlockType = {
    [s.featuredBlockBorder]: variant === "border",
    [s.featuredBlockPullLeft]: variant === "pullLeft",
    [s.featuredBlockMobileBgFull]: variant === "mobileBgFull",
    [s.featuredBlockHeader]: variant === "header"
  };

  const featuredBlockTheme = {
    [s.themeNeonGreen]: theme === "neonGreen",
    [s.themeOrange]: theme === "orange",
    [s.themeLightOrange]: theme === "lightOrange",
    [s.themeLightBlue]: theme === "lightBlue",
    [s.themeDarkPurple]: theme === "darkPurple",
    [s.themeYellow]: theme === "yellow",
    [s.themePink]: theme === "pink"
  };
 
  return (
    <div
      className={ClassNames(
        { [s.featuredAbout]: featuredAbout },
        { [s.featuredTriumphs]: featuredTriumphs },
        { [s.featuredCSR]: variant === "featuredCSR" }
      )}
    >
      {smallTitle && (
        <div
          className={ClassNames(
            s.featuredBlockContainer,
            featuredBlockType,
            featuredBlockTheme,
            { [s.reverse]: reverse },
            { [s.smallTitleConsulting]: variant === "featuredConsulting" }
          )}
        >
          <div className={s.leftContent}>
            {icon && (
              <div className={s.icon}>
                <img alt="" src={icon} />
              </div>
            )}
            <div className={s.smallTitle} style={icon && { width: "80%" }}>
              {smallTitle}
              <div className={s.redBlock} />
            </div>
          </div>
          <div className={s.contentWrapper}>
            <div className={s.header} style={headerStyle && headerStyle}>
              {header}
            </div>
          </div>
        </div>
      )}

      <div className={ClassNames(s.headerBlock)}>
        <div className={s.headerBlockImageWrapper}>
          {imageUrl && (
            <div className={s.headerBlockImage}>
              <GatsbyImage
  
          image={getImage(imageUrl)}
          alt={imageAlt && imageAlt.image_alt}
        />
          
            </div>
          )}
        </div>
        {content && (
          <div className={s.headerBlockContentWrapper}>
            <div className={s.headerBlockContent}>{content}</div>

            {footer && <div className={s.footer}>{footer}</div>}
          </div>
        )}
      </div>
    </div>
  );
};

export default FeaturedBlock;
